import { Link } from "react-router-dom";
import { FOOTER_ABOUT_ENABLED } from "../config.js";

/**
 * Site-wide footer — the about paragraphs across the top, then one line:
 * © year itrapswag at the left end, the section links in the middle (LEGAL
 * last), and Instagram at the right end (it read @ITRAPSWAG until
 * 2026-09-30). All set like the header's links (bold caps): the section
 * links white, the two ends grey (the owner, 2026-10-08).
 *
 * The about block is switched off site-wide for now (FOOTER_ABOUT_ENABLED in
 * config.js), which leaves the link line on its own.
 *
 * `compact` drops the about block, for short informational pages where two
 * paragraphs of positioning copy above the links is more than the page is.
 * AuthenticityPage and the other <Footer compact /> callers rely on it.
 */
// The middle of the footer's line, left to right. SHOP and INFO left it (the
// header and the drawer carry them), and LEGAL stands in for TERMS and
// PRIVACY, which its page lists (pages/LegalPage).
const FOOTER_LINKS = [
  // Its own page since 2026-10-02 (pages/SellPage); it used to open Contact.
  { label: "Sell with us", to: "/sell" },
  { label: "Rental", to: "/rental" },
  { label: "Authenticity", to: "/authenticity" },
  { label: "Contact", to: "/contact" },
  { label: "Legal", to: "/legal" },
];

export default function Footer({ compact = false }) {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {FOOTER_ABOUT_ENABLED && !compact && (
        <div className="site-footer__about">
          <p className="site-footer__about-text">
            itrapswag is a curated online clothing resale platform specializing in
            luxury and designer pieces. We source premium second-hand clothing
            from trusted channels and offer them through our featured collection. Based in the US, we ship
            internationally and provide transparent pricing, detailed condition notes, and
            secure payment options.
          </p>
          <p className="site-footer__about-text">
            All information can be viewed in full in the Info, Privacy, and/or ToS.
          </p>
        </div>
      )}

      <div className="site-footer__bottom">
        <small className="site-footer__copyright">© {year} itrapswag</small>
        {/* The middle of the line: the section links, LEGAL last. */}
        <div className="site-footer__center">
          <nav className="site-footer__nav" aria-label="Footer">
            {FOOTER_LINKS.map((link) => (
              <Link key={link.label} to={link.to}>{link.label}</Link>
            ))}
          </nav>
        </div>
        {/* Instagram at the right end, opposite the copyright. It keeps the
            legal class, so it wears the legal links' grey, as the one link
            that leaves the site. */}
        <nav className="site-footer__legal site-footer__social" aria-label="Social">
          <a
            href="https://www.instagram.com/itrapswag/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram (opens in a new tab)"
          >
            Instagram<span className="site-footer__ext" aria-hidden="true">↗</span>
          </a>
        </nav>
      </div>
    </footer>
  );
}
